import script from "./KnowlegeList.vue?vue&type=script&setup=true&lang=ts"
export * from "./KnowlegeList.vue?vue&type=script&setup=true&lang=ts"

import "./KnowlegeList.vue?vue&type=style&index=0&id=c407452e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c407452e"]])

export default __exports__